<template>
<div class="wrapper" v-if="actionPlanDTO!=null">
    <div class="topRow">
        <v-icon scale="1.8" class="aok" :name="icon"></v-icon> <span class="title">{{title}}</span>
    </div>

    <div v-for="(row,idx) in actionPlanDTO.rows" :key="idx" class="actionRow">
        <div>{{row.title}}</div>
        <div>{{row.value}}</div>
    </div>

</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ActionPlanWidget',

  props: {
      widgetData: Object
  },

  data() {
    return {
        actionPlanDTO: null
    }
  },

  computed: {
    ...mapGetters(['pages']),

    icon() {
        switch(this.widgetData.action) {
            case 'MAINTAIN':
               return "thumbs-up"
            case 'OBSERVE':
                return "search-plus"
            case 'ADAPT':
                return "check-square"
            case 'PRIORITISE':
                return "cogs"
        }
      return 'question-circle'
    },

    title() {
        switch(this.widgetData.action) {
            case 'MAINTAIN':
                return this.$t('ACTION_MAINTAIN')
            case 'OBSERVE':
                return this.$t('ACTION_OBSERVE')
            case 'ADAPT':
                return this.$t('ACTION_ADAPT')
            case 'PRIORITISE':
                return this.$t('ACTION_PRIORITISE')
        }

        return "?"
    }

},

  methods: {
      requestData(requester) {
          requester.addActionPlanRequest(this.dataCallback, this.widgetData.extname);
      },

      dataCallback(dto) {
          this.actionPlanDTO = dto
      },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wrapper {
    background-color: white;
    display: flex;
    flex-flow: column;
    height: 100%;
    padding: 1em;
  }

  .topRow {
      display: flex;
      flex-flow: row;
      align-items: baseline;
      margin-bottom: 1em;
  }

  .actionRow {
      display: flex;
      flex-flow: row;
      justify-content: space-between;
  }

  .title {
    margin-left: 16px;
    font-size: 1.5em;
  }

  .value {
    color: white;
    font-size: 3em;
    text-align: center;
    padding-top: 1em;
  }

</style>
